import SessionCarouselCard from "./SessionCarouselCard";

export default SessionCarouselCard;
